import { useState, useEffect } from "react";

/**
 * Debounce hook
 * @param {*} value - value to debounce
 * @param {number} delay - debounce delay in ms
 */
export default function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
